import { Alert, Grid } from "@mui/material";
import { useContext, useEffect } from 'react';
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { SistemaTipo } from "../../../../types/enum/enum";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import SeccionLCTCDatosOperacion from "./components/SeccionLCTCDatosOperacion";
import SeccionLCTCLimitesTabla from "./components/SeccionLCTCLImitesTabla";
import { useOperacionLCTC } from "./hooks/useOperacionLCTC";
import { OperacionLCTC } from "./types/types";


interface SistemaLCTCContentProps {
    operacion: OperacionLCTC
}

const SistemaLCTCContent = ({operacion}: SistemaLCTCContentProps) => {
    return (
        <>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <SeccionLCTCDatosOperacion
                        operacion={operacion}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SeccionLCTCLimitesTabla operacion={operacion} />
                </Grid>

                <Grid item xs={12}>
                    <SeccionFirmas
                        codSistema={SistemaTipo.LCTC}
                        idOperacion={operacion.id}
                    />
                </Grid>
            </Grid>
        </>
    )
}

function SistemaLCTC() {
    const {idOperacion} = useContext<ContextOperacionType>(ContextOperacion);
    const {status, operacion} = useOperacionLCTC(idOperacion);
    const {showLoader, hideLoader} = useLoader();

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status]);

    if (!operacion) {
        return null;
    }

    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    return (
        <SistemaLCTCContent
            operacion={operacion}
        />
    )
}

export default SistemaLCTC;